import { useMemo } from 'react';
import type { DeliveryType } from 'shared/src/api/goodsService/getGoodsOptions';
import { useIsBottomSheetGiftMode } from '../../hooks/useIsBottomSheetGiftMode';
import { useGetOrderDeadlineText } from '../../hooks/useGetOrderDeadlineText';
import { PricingTodayDeliveryBadge } from './PricingTodayDeliveryBadge';
import { PricingThirdPLDeliveryBadge } from './PricingThirdPLDeliveryBadge';

export const PricingBadge = ({
  deliveryType,
  salesMethod,
}: {
  deliveryType: DeliveryType;
  salesMethod?: 'PRE_ORDER' | null;
}) => {
  const isGiftMode = useIsBottomSheetGiftMode();
  const isPreOrder = salesMethod === 'PRE_ORDER';

  const isTodayDelivery = useMemo(() => {
    if (isGiftMode) return false;

    return deliveryType === 'today' || deliveryType === 'shak';
  }, [deliveryType, isGiftMode]);

  const isThirdPLDelivery = useMemo(() => {
    if (isGiftMode) return false;

    return deliveryType === 'third_pl';
  }, [deliveryType, isGiftMode]);

  const getDeadlineText = useGetOrderDeadlineText();

  const orderDeadline = useMemo(() => {
    if (!isTodayDelivery && !isThirdPLDelivery) return null;

    return getDeadlineText({ delivery_type: deliveryType }).text;
  }, [isTodayDelivery, isThirdPLDelivery, getDeadlineText, deliveryType]);

  if (isPreOrder) {
    return null;
  }

  if (isThirdPLDelivery) {
    return <PricingThirdPLDeliveryBadge orderDeadline={orderDeadline} />;
  }

  if (isTodayDelivery) {
    return <PricingTodayDeliveryBadge orderDeadline={orderDeadline} />;
  }

  return null;
};
